import { LocalPhone } from "@mui/icons-material";
import { Box, Card, Container, Grid, Input, Typography } from "@mui/material";
import { ErrorMessage, Form, FormikValues, useFormikContext } from "formik";
import React, { FC } from "react";

import Button from "../../common/Button";

import { useNavigate } from "react-router-dom";
import IMAGES from "../../../assets/themes/images/images";
import RoutingList from "../../../utils/RoutingList";
import styles from "./login.module.scss";


const LoginForm: FC = () => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const navigate = useNavigate();

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value, true);
  };

  const navigateToForgotPassword = () => {
    navigate(RoutingList.login.forgetPassword);
  };

  return (

    <Box className={styles.pageBox}>

      {/* new header */}
      <Box className={styles.NewHeaders}>
        <Container maxWidth="xl">
          <Grid container className="align-items-center">
            <Grid item md={2}>
              <img
                src={IMAGES.Logo}
                alt=""
                className=""
              />
            </Grid>
            <Grid item md={8}>
              <div className={`text-center ${styles.HeaderContentCenter}`}>

                <Typography className={`font-size-16 text-danger font-weight-medium ${styles.textBase}`}>
                  <b>Jayprabha Medanta Super Specialty Hospital</b> is <b>Bihar government</b> & <b>Global health Patliputra Pvt ltd</b> <br />  (Public Private Partnership Project)
                  {/* Global Health Limited and Bihar Government Public Private Partnership Patient Referral Portal GHPPL is Unit of GHL */}
                </Typography>
                <h1 className={`text-danger ${styles.headingH1}`}>
                  Patient Referral Portal
                </h1>
                <Typography className={`font-size-8 text-danger font-weight-small`} style={{ margin: '0' }}>
                  <b>(A unit of GHPPL)</b>
                </Typography>

              </div>

            </Grid>
            <Grid item md={2}>
              <img
                src={IMAGES.BihaarGovtLogo2}
                alt=""
                className="float-right"
              />
            </Grid>
          </Grid>
        </Container>

      </Box>
      {/* new header */}

      {/* <Navbar isLogoOnly={true} /> */}


      <Box>
        <Grid container>
          <Grid item md={12}>
            <div className={styles.bannerFulls}>
              <figure className={styles.bannerImg}>
                <img
                  className="img-fluid"
                  src={IMAGES.BannerFull}
                  alt="announcement-img"
                />
              </figure>
              <div className={styles.bannerCaptionForm}>
                <Container maxWidth="xl" className={styles.captInner}>
                  <Box className={styles.formNew}>
                    <Form >
                      <Card className={styles.loginCard} variant="outlined">
                        <div className={styles.cardBody2}>
                          <div className={`text-center ${styles.loginHeadTop}`}>
                            <h2 className="font-weight-semi-bold mb-1">
                              Sign In
                            </h2>
                            {/* <p className="font-size-18 text-dark">New Here?  <a href="" className="text-danger">Create an Account</a></p> */}
                          </div>
                          <div className="form-group">
                            <label className="mb-1 font-size-14 font-weight-medium">
                              Email
                            </label>
                            <Input
                              type="text"
                              className="form-control-new"
                              name="email"
                              placeholder="Email"
                              value={values?.email}
                              onChange={inputHandler}
                            />
                            <ErrorMessage
                              name="email"
                              render={(msg) => (
                                <p className="error-text mt-1 mb-1">{msg}</p>
                              )}
                            />
                          </div>
                          <div className="form-group">
                            <div className="mb-1 d-flex justify-content-between align-items-center">
                              <label className="font-size-14 font-weight-medium">
                                Password
                              </label>
                              <button
                                type="button"
                                className="btn btn-link text-white font-weight-semi-bold font-size-14"
                                onClick={navigateToForgotPassword}
                              >
                                Forgot Password?
                              </button>
                            </div>
                            <Input
                              type="password"
                              className="form-control-new"
                              name="password"
                              placeholder="Password"
                              value={values?.password}
                              onChange={inputHandler}
                            />
                            <ErrorMessage
                              name="password"
                              render={(msg) => (
                                <p className="error-text mt-1 mb-1">{msg}</p>
                              )}
                            />
                          </div>
                          <div
                            className={`d-flex justify-content-center ${styles.loginFooter}`}
                          >
                            <Button color="alert" className="signin-btn" type="submit">
                              Sign In
                            </Button>
                          </div>
                        </div>
                      </Card>
                    </Form>
                  </Box>
                </Container>

              </div>
            </div>
          </Grid>

          {/* <Grid item md={12}>
            <Box className={styles.bannerContent2}>
              <Box className={styles.loginBox}>
                <Form className={styles.loginWrap}>
                  <Card className={styles.loginCard} variant="outlined">
                    <div className={styles.cardBody2}>
                      <div className={`text-center ${styles.loginHeadTop}`}>
                        <h2 className="font-weight-semi-bold mb-1">
                          Sign In
                        </h2>                        
                      </div>
                      <div className="form-group">
                        <label className="mb-1 font-size-14 font-weight-medium">
                          Email
                        </label>
                        <InputField
                          type="text"
                          className="form-control"
                          name="email"
                          placeholder="Email"
                          value={values?.email}
                          onChange={inputHandler}
                        />
                      </div>
                      <div className="form-group">
                        <div className="mb-1 d-flex justify-content-between align-items-center">
                          <label className="font-size-14 font-weight-medium">
                            Password
                          </label>
                          <button
                            type="button"
                            className="btn btn-link font-weight-semi-bold font-size-14"
                            onClick={navigateToForgotPassword}
                          >
                            Forgot Password?
                          </button>
                        </div>
                        <InputField
                          type="password"
                          className="form-control"
                          name="password"
                          placeholder="Password"
                          value={values?.password}
                          onChange={inputHandler}
                        />
                      </div>
                      <div
                        className={`d-flex justify-content-center ${styles.loginFooter}`}
                      >
                        <Button color="alert" className="signin-btn" type="submit">
                          Sign In
                        </Button>
                      </div>
                    </div>
                  </Card>
                </Form>
              </Box>              
            </Box>
          </Grid> */}
        </Grid>
      </Box>
      <Container>
        {/* <Box className={styles.loginBox}>
          <Form className={styles.loginWrap}>
            <Card className={styles.loginCard} variant="outlined">
              <div className={styles.cardBody}>
                <div className={`text-center ${styles.headerTop}`}>
                  <h2 className="font-weight-semi-bold mb-1">
                    Sign In to Medanta
                  </h2>
                </div>
                <div className="form-group">
                  <label className="mb-1 font-size-14 font-weight-medium">
                    Email
                  </label>
                  <InputField
                    type="text"
                    className="form-control"
                    name="email"
                    placeholder="Email"
                    value={values?.email}
                    onChange={inputHandler}
                  />
                </div>
                <div className="form-group">
                  <div className="mb-1 d-flex justify-content-between align-items-center">
                    <label className="font-size-14 font-weight-medium">
                      Password
                    </label>
                    <button
                      type="button"
                      className="btn btn-link font-weight-semi-bold font-size-14"
                      onClick={navigateToForgotPassword}
                    >
                      Forgot Password?
                    </button>
                  </div>
                  <InputField
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="Password"
                    value={values?.password}
                    onChange={inputHandler}
                  />
                </div>
                <div
                  className={`d-flex justify-content-center ${styles.loginFooter}`}
                >
                  <Button color="alert" type="submit">
                    Sign In
                  </Button>
                </div>
              </div>
            </Card>
          </Form>
        </Box> */}
        <Box sx={{ marginTop: "2.25rem", textAlign: "center" }}>
          <p className={`mb-10 ${styles.forMore}`}>
            <LocalPhone className={`text-danger ${styles.iconPhone}`} />
            For more information, call us at{" "}
            <a
              className="text-danger font-weight-bold text-decoration-none"
              href="tel:O6123505123"
            >
              {" "} O6123505123
            </a>
            {" "}(General Quarries),
            <a
              className="text-danger font-weight-bold text-decoration-none"
              href="tel:06123505124"
            >
              {" "}06123505124
            </a>
            {" "}(Admin & IT Queries)
          </p>
          <p className="font-size-14">*Terms and conditions apply</p>
        </Box>
      </Container>
    </Box>
  );
};

export default LoginForm;
